import { render, staticRenderFns } from "./SelectUsers.vue?vue&type=template&id=5820a28c&scoped=true"
import script from "./SelectUsers.vue?vue&type=script&lang=js"
export * from "./SelectUsers.vue?vue&type=script&lang=js"
import style0 from "./SelectUsers.vue?vue&type=style&index=0&id=5820a28c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820a28c",
  null
  
)

export default component.exports